var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTubeFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.751 7.50049C24.751 7.50049 24.5068 5.77686 23.7549 5.02002C22.8027 4.02393 21.7383 4.01904 21.25 3.96045C17.7539 3.70654 12.5049 3.70654 12.5049 3.70654H12.4951C12.4951 3.70654 7.24609 3.70654 3.75 3.96045C3.26172 4.01904 2.19727 4.02393 1.24512 5.02002C0.493164 5.77686 0.253906 7.50049 0.253906 7.50049C0.253906 7.50049 0 9.52686 0 11.5483V13.4429C0 15.4644 0.249023 17.4907 0.249023 17.4907C0.249023 17.4907 0.493164 19.2144 1.24023 19.9712C2.19238 20.9673 3.44238 20.9331 3.99902 21.0405C6.00098 21.231 12.5 21.2896 12.5 21.2896C12.5 21.2896 17.7539 21.2798 21.25 21.0308C21.7383 20.9722 22.8027 20.9673 23.7549 19.9712C24.5068 19.2144 24.751 17.4907 24.751 17.4907C24.751 17.4907 25 15.4692 25 13.4429V11.5483C25 9.52686 24.751 7.50049 24.751 7.50049ZM9.91699 15.7427V8.71631L16.6699 12.2417L9.91699 15.7427Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeFooter);
export default __webpack_public_path__ + "static/media/YouTubeFooter.f6958d03b1dd7de6e6bfa96b80bdbefc.svg";
export { ForwardRef as ReactComponent };